<template>
    <path d="M4.786 0C2.14 0 0 2.091 0 4.676s2.14 4.676 4.786 4.676c.945 0 1.819-.27 2.56-.73L10.804 12 12 10.83 8.587 7.505c.613-.786.985-1.76.985-2.828C9.572 2.091 7.432 0 4.786 0zm0 1.1c2.027 0 3.66 1.596 3.66 3.576s-1.633 3.576-3.66 3.576-3.66-1.595-3.66-3.576c0-1.98 1.633-3.576 3.66-3.576z"/>
</template>

<script>
export default {
    name: 'searchIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 12 12');
    }
};
</script>
